// Mock data providers
import faqs from './faqs.mock';
import themes from './themes.mock';

export default {
  faqs,
  themes,
};
